'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _EDSContext = require('./../EDSContext/EDSContext');

var _core = require('@material-ui/core');

var _constants = require('./internal/constants.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        root: {
            background: 'transparent',
        },
        hidden: {
            width: 0,
            height: 0,
            color: 'transparent'
        }
    };
};

/**
 * Use `StepProgress` to display a user's progress through numbered steps.
 * @done true
 * @updated false
 * @versionAdded v0.0.14
 * @examples
 *  LinearHorizontalExample
 *  NonLinearExample
 *  AlternativeLabelExample
 *  VerticalExample
 *  ErrorStateExample
 *  MobileStepperExample
 *  NonLinearDisabledExample
 */
var StepProgress = _react2.default.forwardRef(function (props, ref) {
    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        stepLabel = _useState2[0],
        setStepLabel = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        hasStepError = _useState4[0],
        setHasStepError = _useState4[1];

    var _useState5 = (0, _react.useState)(''),
        _useState6 = _slicedToArray(_useState5, 2),
        errorLabel = _useState6[0],
        setErrorLabel = _useState6[1];

    var localRef = ref || (0, _react.useRef)();

    var classes = props.classes,
        edsContext = props.edsContext,
        rest = _objectWithoutProperties(props, ['classes', 'edsContext']);

    var classOverrides = {
        root: classes.root
    };

    // This effect sets the `aria-label` to say `<step-label>, <step-number> / <total-steps>
    // by the screen reader by extracting all the step labels
    (0, _react.useEffect)(function () {
        var stepLabels = localRef.current.querySelectorAll('.' + _constants.STEP_LABEL_CLASSNAME);

        stepLabels.forEach(function (localStepLabel, i) {
            localStepLabel.setAttribute('aria-label', edsContext.formatMessage('component.StepProgress.a11yLabel', {
                label: localStepLabel.textContent.replace(/^[0-9]/, ''),
                step: i + 1,
                totalSteps: stepLabels.length
            }));
        });
    }, [localRef, edsContext]);

    // This effect sets the div with current step content with error message if there is one.
    (0, _react.useEffect)(function () {
        try {
            var stepLabels = localRef.current.querySelectorAll('.' + _constants.STEP_LABEL_CLASSNAME);
            var activeStep = stepLabels[props.activeStep];
            var localStepLabel = localRef.current.querySelectorAll('.' + _constants.STEP_PROGRESS_STEP_CLASSNAME)[props.activeStep];
            var localErrorLabel = localStepLabel && localStepLabel.querySelector('.' + _constants.STEP_LABEL_ERROR_CLASSNAME);
            var secondaryLabel = localErrorLabel ? localErrorLabel.textContent : '';
            setHasStepError(activeStep ? activeStep.classList.contains(_constants.STEP_LABEL_HAS_ERROR_CLASSNAME) : '');
            setErrorLabel(secondaryLabel);
            setStepLabel(props.activeStep + 1 > stepLabels.length ? edsContext.formatMessage('component.MobileStepper.allStepsCompleted') : activeStep && activeStep.getAttribute('aria-label'));
        } catch (error) {
            console.log(error);
        }
    }, [props.activeStep, localRef, edsContext]);

    var getText = function getText() {
        var errorMessage = edsContext.formatMessage('component.StepProgress.errorMessage', {
            errorMessage: errorLabel
        });
        var text = stepLabel;

        text += hasStepError ? ', ' + edsContext.formatMessage('component.StepProgress.errorMessageTitle') : '';
        text += errorLabel.length ? ', ' + errorMessage : '';

        return text;
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_core.Stepper, Object.assign({}, rest, {
            classes: classOverrides,
            ref: localRef
        })),
        _react2.default.createElement(
            'div',
            { 'aria-live': 'assertive', className: classes.hidden + ' ' + _constants.ACTIVE_STEP_SCREEN_READER_TEXT },
            getText()
        )
    );
});

StepProgress.muiName = 'Stepper';
StepProgress.displayName = 'StepProgress';

StepProgress.propTypes = {
    /**
     * Set the active step (zero based index).
     */
    activeStep: _propTypes2.default.number,
    /**
     * If set to 'true' and orientation is `horizontal`,
     * then the step label will be positioned under the icon.
     */
    alternativeLabel: _propTypes2.default.bool,
    /**
     * Two or more `<Step />` components.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object.isRequired,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * A component to be placed between each step.
     */
    connector: _propTypes2.default.element,
    /**
     * If set the `StepProgress` will not assist in controlling steps for linear flow.
     */
    nonLinear: _propTypes2.default.bool,
    /**
     * The stepper orientation (layout flow direction).
     */
    orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
};

StepProgress.defaultProps = {
    activeStep: 0,
    alternativeLabel: false,
    connector: _react2.default.createElement(_core.StepConnector, null),
    nonLinear: false,
    orientation: 'horizontal'
};

exports.default = (0, _EDSContext.withEDSContext)((0, _styles2.default)(styles)(StepProgress));